import stbApiGateway from '@/services/stbApiGateway';
import * as types from '../../../mutationTypes';

export const fetchRiskCategories = async (
  { state, commit },
  { excursionType, filterBy, oauthSignature, clientSid }
) => {
  const stbApi = stbApiGateway(state.axios);
  const response = await stbApi.getRiskCategories(
    excursionType,
    filterBy,
    oauthSignature,
    clientSid
  );
  if (response) {
    commit(types.SET_RISK_CATEGORIES, response);
  }
  return response;
};
